import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authservice: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authservice.user) {
      this.authservice.callbackUrl = state.url;

      return this.authservice.userInfo$.pipe(
        filter(userInfo => !!userInfo),
        map(userInfo => !!userInfo)
      );
    } else {
      this.authservice.login(state.url);
    }
  }
}
